import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { WIDGET_STATE } from '../constants/app';
import { WIDGET, HEADER } from '../constants/dimensions';
import { COLORS } from '../constants/styles';
import { CONNECTION_STATE } from '../constants/connection-state';
import { reconnectFaye } from '../actions/faye';

class ConnectionErrorBanner extends Component {
    static propTypes = {
        appUserId: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
        widgetSize: PropTypes.string.isRequired,
        widgetState: PropTypes.symbol.isRequired,
        connectionState: PropTypes.symbol.isRequired,
        couldNotConnectText: PropTypes.string.isRequired,
        couldNotConnectInnerText: PropTypes.string.isRequired,
        couldNotConnectWithRetryText: PropTypes.string.isRequired,
        couldNotConnectWithRetryInnerText: PropTypes.string.isRequired,
    };

    _onWindowUnload = () => {
        this.unloading = true;
    };

    _onRetryClick = () => {
        reconnectFaye();
    };

    UNSAFE_componentWillMount() {
        window.addEventListener('beforeunload', this._onWindowUnload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this._onWindowUnload);
    }

    shouldComponentUpdate() {
        return !this.unloading;
    }

    render() {
        const {
            appUserId,
            connectionState,
            widgetSize,
            widgetState,
            couldNotConnectText,
            couldNotConnectInnerText,
            couldNotConnectWithRetryText,
            couldNotConnectWithRetryInnerText,
        } = this.props;

        const styles = {
            banner: {
                base: {
                    top: `${9 + HEADER.HEIGHT + 10}px`,
                    left: '10px',
                    borderRadius: '6px',
                    position: 'absolute',
                    width: 'calc(100% - 20px)',
                    backgroundColor: 'rgba(69,79,91,0.94)',
                    boxShadow: '0 2px 6px 0 rgba(71,69,123,0.2), 0 4px 14px 0 rgba(71,69,123,0.03)',
                    display: 'inlineBlock',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease-in-out',
                    opacity: 0,
                },
                shown: {
                    opacity: 1,
                    top: `${9 + HEADER.HEIGHT}px`,
                },
            },
            errorText: {
                color: COLORS.WHITE,
                textAlign: 'center',
                fontSize: '13px',
                padding: '10px 0px 11px 0px',
                lineHeight: 1.25,
                wordWrap: 'break-word',
                margin: '0 10px',
            },
            fixedContainer: {
                zIndex: 2,
                position: 'fixed',
                width: WIDGET[`WIDTH_${widgetSize.toUpperCase()}`],
            },
            embeddedModeContainer: {
                zIndex: 2,
            },
            retryButton: {
                textDecoration: 'underline',
                cursor: 'pointer',
            },
        };

        const bannerStyle = { ...styles.banner.base };

        // A navigator.onLine value of undefined means the browser lacks support
        // In this case we assume internet connectivity
        const noInternet = navigator.onLine === false;
        const isConnected = connectionState === CONNECTION_STATE.CONNECTED;
        const showBanner = noInternet || (appUserId && !isConnected);

        if (showBanner) {
            let retryTextToUse;
            let bannerTextToUse;

            switch (connectionState) {
                case CONNECTION_STATE.DISCONNECTED:
                    bannerTextToUse = couldNotConnectText;
                    retryTextToUse = couldNotConnectInnerText;
                    break;
                // if connection state is connected but onLine is false, keep showing the banner
                case CONNECTION_STATE.CONNECTED:
                case CONNECTION_STATE.DISCONNECTED_WITH_RETRY:
                    bannerTextToUse = couldNotConnectWithRetryText;
                    retryTextToUse = couldNotConnectWithRetryInnerText;
                    break;
                default:
                    bannerTextToUse = '';
                    retryTextToUse = '';
            }

            const retryStringReplace = '{retry}';
            const textFirstPart = bannerTextToUse.substring(0, bannerTextToUse.indexOf(retryStringReplace));
            const textLastPart = bannerTextToUse.substring(
                bannerTextToUse.indexOf(retryStringReplace) + retryStringReplace.length,
            );

            Object.assign(bannerStyle, styles.banner.shown);

            this.text = (
                <div className="floating-banner-text" style={styles.errorText}>
                    {textFirstPart}
                    <a style={styles.retryButton} onClick={this._onRetryClick}>
                        {retryTextToUse}
                    </a>
                    {textLastPart}
                </div>
            );
        }

        const containerStyle =
            widgetState === WIDGET_STATE.EMBEDDED ? styles.embeddedModeContainer : styles.fixedContainer;
        return (
            <div style={containerStyle}>
                <div className="floating-banner" style={bannerStyle}>
                    {this.text}
                </div>
            </div>
        );
    }
}

export default connect(
    ({ appState: { connectionState, widgetSize, widgetState }, ui: { text }, user: { _id: appUserId } }) => {
        return {
            widgetSize,
            widgetState,
            appUserId,
            connectionState: connectionState,
            couldNotConnectText: text.couldNotConnect,
            couldNotConnectInnerText: text.couldNotConnectInner,
            couldNotConnectWithRetryText: text.couldNotConnectWithRetry,
            couldNotConnectWithRetryInnerText: text.couldNotConnectWithRetryInner,
        };
    },
    undefined,
    undefined,
    {
        forwardRef: true,
    },
)(ConnectionErrorBanner);
